module.exports = __webpack_public_path__ + "static/media/zoleCoins.caf2f1e7.svg";